export default __webpack_public_path__ + "static/media/gallery_00.a0be78ec.jpg";